import React from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router';
// Styles
import './intro.scss';
import AppStore from 'cd-eft/models/Stores/AppStore';

const IntroComponent = (props: any) => {
  const history = useHistory();

  return (
    <div>
      <div className="hydrology-intro-main">
        <div className="hydrology-intro-title">
          <h1>Hydrology</h1>
        </div>
      </div>
      <div className="hydrology-intro-banner row">
        <div className="col-md-12">
          <h5>
            Peak discharge is determined by procedures contained in NRCS Engineering Field Handbook, Chapter 2.
            Information needed to use this procedure include watershed characteristics (drainage area, curve number,
            watershed length, watershed slope) and rainfall amount and distribution.
          </h5>
          <h5> The method applies when:</h5>
        </div>
        <div className="col-md-6">
          <ul className='m-0'>
            <li>- Watershed is accurately represented by a single runoff curve number between 30 and 100.</li>
            <li>- Watershed area is between 1 and 2000 acres.</li>
            <li>- Watershed hydraulic length is between 200 and 26000 feet.</li>
          </ul>
        </div>
        <div className="col-md-6">
          <ul className='m-0'>
            <li>- Average watershed slope is between 0.5 and 64 percent.</li>
            <li>- No valley or reservoir routing is required.</li>
            <li>- Maximum rainfall is between 0 and 70 inches.</li>
            <li>- Urban land use within the watershed does not exceed 10%.</li>
          </ul>
        </div>
      </div>
      <div className="row quick-link-row">
        <div className="offset-md-1 col-md-3">
          <button
            className="quick-link-button usa-button usa-button--outline"
            onClick={() => {
              AppStore.createProjectClassId = 4;
              history.push('/projects');
            }}
          >
            Single Watershed
          </button>
          <p>
            <strong>Single Watershed:</strong> Use this GIS-based workflow that includes authoritative data to calculate
            Drainage Area, Watershed Length, and Runoff Curve Number.
          </p>
        </div>
        <div className="col-md-3">
          <button
            className="quick-link-button usa-button usa-button--outline"
            // disabled
            onClick={() => {
              history.push('/analysis/hydrology/hydrology-calculator');
            }}
          >
            Hydrology Calculator
          </button>
          <p>
            <strong>Hydrology Calculator:</strong> Use this tool to quickly compute peak flow and runoff with a few inputs.
          </p>
        </div>
        <div className="col-md-3">
          <button
            className="quick-link-button usa-button usa-button--outline"
            disabled
            onClick={() => {
              // history.push('/analysis/hydrology/rainfall-drainage');
            }}
          >
            Multiple Watersheds
          </button>
          <p>
            <strong>Multiple Watersheds:</strong> This page is under development.
          </p>
        </div>
      </div>
    </div>
  );
};

export const Intro = observer(IntroComponent);
